'use client'

import { DocumentResizableContainer__PUBLIC } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/document-resizable-container'
import { PropertiesPanelLayout__PUBLIC } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/properties-panel/pp-layout'
import { Tabs } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/tabs'
import { TabContent } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/tab-content'
import { ExplorerTab } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/sidebar/tab'
import { CommitsTab } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/history/_components/sidebar/tab'
import { redirect, usePathname } from 'next/navigation'
import { run } from '@basehub/utils'
import * as React from 'react'
import { ChangelogTab } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/changelog/sidebar/changelog-tab'
import { useHasRendered } from '~/hooks/use-has-rendered'
import { Loader } from '~/components/loader'

export const PublicRepo = () => {
  const pathname = usePathname()
  const page = pathname.split('/').filter(Boolean)[2]
  const hasRendered = useHasRendered()

  const shouldRedirect = pathname && !page
  const isNotFound = pathname
    ? !page || !['explore', 'history', 'changelog'].includes(page)
    : false

  React.useEffect(() => {
    if (shouldRedirect) {
      redirect(
        window.location.pathname +
          '/explore' +
          window.location.search +
          window.location.hash
      )
    }
  }, [shouldRedirect])

  return (
    <>
      <Loader
        done={shouldRedirect ? false : hasRendered}
        notFound={shouldRedirect ? false : isNotFound}
      />

      {hasRendered && (
        <React.Suspense fallback={null}>
          <div className="-mt-[var(--header-height)] flex h-screen overflow-hidden bg-dark-bg pt-[var(--header-height)]">
            <DocumentResizableContainer__PUBLIC>
              {run(() => {
                switch (page) {
                  case 'explore':
                    return <ExplorerTab />
                  case 'history':
                    return <CommitsTab />
                  case 'changelog':
                    return <ChangelogTab />
                }
              })}
            </DocumentResizableContainer__PUBLIC>
            <div className="[--editor-footer-height:8px] [--editor-breadcrumb-height:32px] mb-[var(--editor-footer-height)] flex-grow !overflow-clip !rounded-xl border border-dark-border-solid bg-dark-base min-w-20">
              <div className="relative flex h-screen max-h-screen flex-col overflow-hidden [--tabs-height:40px]">
                <div>
                  <Tabs />
                </div>
                <div
                  className="flex items-stretch flex-grow"
                  style={{
                    ['--editor-height' as string]:
                      'calc(100vh - var(--header-height) - var(--tabs-height) - var(--editor-footer-height) - var(--editor-breadcrumb-height))',
                  }}
                  id="editor-main-content"
                >
                  <TabContent />
                </div>
              </div>
            </div>
            <PropertiesPanelLayout__PUBLIC />
          </div>
        </React.Suspense>
      )}
    </>
  )
}
